import React, { useState } from "react";
import Logo from "../assets/LogoIconFooter";
import PrivacyPolicy from "./auth/privacyPolicy";
import TermsOfService from "./auth/termsOfService";

const footerLinks = [
  {
    category: "Legal",
    links: [
      { title: "Privacy Policy", type: "privacy" },
      { title: "Terms of Service", type: "terms" },
    ],
  },
  {
    category: "Contact",
    links: [{ title: "hello@swipey.ai", href: "mailto:hello@swipey.ai" }],
  },
];

const Footer = () => {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  const handleClick = (link) => {
    if (link.type === "privacy") setShowPrivacy(true);
    if (link.type === "terms") setShowTerms(true);
  };

  const handleAcceptPrivacy = () => setShowPrivacy(false);
  const handleAcceptTerms = () => setShowTerms(false);

  return (
    <>
      <div className="footer">
        <div className="footer-top">
          <div className="footer-left">
            <Logo className="footer-logo" />
            <div className="footer-texts">
              <div className="footer-text">
                Swipey AI girlfriends provide immersive experiences that feel
                real, allowing you to create, generate images, and chat with
                your AI characters.
              </div>{" "}
              <div className="footer-text">
                INVAI LTD
                <br /> Company ID: ΗΕ 458964
                <br /> Agios Alexiou 1, Strovolos, 2054, Nicosia, Cyprus
              </div>
            </div>
          </div>
          <div className="footer-right">
            {footerLinks.map((section) => (
              <div className="footer-col" key={section.category}>
                <h4 className="footer-category">{section.category}</h4>
                <div className="footer-links">
                  {section.links.map((link) => (
                    <a
                      className="footer-link"
                      key={link.title}
                      onClick={() => handleClick(link)}
                      href={link.href}
                    >
                      {link.title}
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>{" "}
        <div className="footer-bot">
          <div className="footer-text-bot">© 2025 - All rights reserved</div>
        </div>
      </div>
      {showPrivacy && (
        <PrivacyPolicy
          isOpen={showPrivacy}
          onClose={() => setShowPrivacy(false)}
          onAccept={handleAcceptPrivacy}
        />
      )}
      {showTerms && (
        <TermsOfService
          isOpen={showTerms}
          onClose={() => setShowTerms(false)}
          onAccept={handleAcceptTerms}
        />
      )}
    </>
  );
};

export default Footer;
